module.exports = __webpack_public_path__ + "static/media/Cyberport_logo.3c3c48ac.png";